import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DonutComponent } from './donut.component';
import { PlIconModule } from '@app/icon-library/lib/pl-icon.module';

@NgModule({
  imports: [CommonModule, PlIconModule],
  declarations: [DonutComponent],
  exports: [DonutComponent],
})
export class DonutModule {}
